import { ClearanceAttributes } from "../../types/auth";

export const staffClearanceAttributes: ClearanceAttributes = {
    codes: ['GRL', 'AGRL', 'VGA', 'WEB', 'KAPL', 'KWL', 'JGVL', 'GVL', 'JL'],
    descriptors: ['Woudloperleiding']
}

export const groupClearanceCodes = ['O1306G'];